export default __webpack_public_path__ + "static/media/vectorpaint.b36961b4.svg";